import { isDefined } from './is-defined';
import { resolveSchemaWithRef } from './resolve-schema-with-ref';
const PRIMITIVE_TYPES = ['string', 'number', 'boolean'];
export const weightSchemaAgainstModel = (model, schema, definitions) => {
    if (!isDefined(model) || !isDefined(schema))
        return 0;
    const resolvedSchema = resolveSchemaWithRef(schema, definitions);
    const modelType = typeof model;
    if (PRIMITIVE_TYPES.includes(modelType)) {
        if (resolvedSchema.type === modelType) {
            return 10;
        }
        return 0;
    }
    if (typeof model === 'object' && Object.keys(model).length === 0 && resolvedSchema.type === 'object') {
        return 10;
    }
    return Object.entries(model).reduce((points, [modelKey, modelValue]) => {
        var _a, _b;
        if (isDefined(resolvedSchema.properties)) {
            if (resolvedSchema.properties[modelKey]) {
                points += 1;
            }
            const resolvedSchemaProperty = resolveSchemaWithRef(resolvedSchema.properties[modelKey], definitions);
            if (isDefined(resolvedSchemaProperty) && typeof modelValue === resolvedSchemaProperty.type) {
                points += 10;
            }
            if (isDefined(resolvedSchemaProperty) && typeof modelValue === 'object') {
                points += weightSchemaAgainstModel(modelValue, resolvedSchemaProperty, definitions);
            }
        }
        (_a = resolvedSchema.anyOf) === null || _a === void 0 ? void 0 : _a.forEach((anyOfSchema) => {
            const anyOfResolvedSchema = resolveSchemaWithRef(anyOfSchema, definitions);
            points += weightSchemaAgainstModel(model, anyOfResolvedSchema, definitions);
        });
        (_b = resolvedSchema.oneOf) === null || _b === void 0 ? void 0 : _b.forEach((oneOfSchema) => {
            const oneOfResolvedSchema = resolveSchemaWithRef(oneOfSchema, definitions);
            points += weightSchemaAgainstModel(model, oneOfResolvedSchema, definitions);
        });
        return points;
    }, 0);
};
//# sourceMappingURL=weight-schemas-against-model.js.map